import { createTheme } from '@mui/material/styles';
import { APP_COLORS as C } from '../assets/app-only/colors';

const FONTS = {
  serif: '"DM Serif Display", Georgia, serif',
  sans: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const sharedComponents = {
  MuiAccordion: {
    styleOverrides: {
      root: {
        '&:before': { height: 0 },
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: C.espresso,
        color: C.creamText,
        fontSize: '12px',
        fontFamily: FONTS.sans,
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '12px',
      },
    },
  },
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        '&.Mui-checked': {
          color: '#ffffff',
          '& + .MuiSwitch-track': {
            backgroundColor: C.success,
            opacity: 1,
          },
        },
      },
    },
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: C.gold,
      dark: C.goldDark,
      light: C.ivory,
      contrastText: C.espresso,
    },
    secondary: {
      main: C.goldDark,
      contrastText: C.offWhite,
    },
    background: {
      default: C.cream,
      paper: C.offWhite,
    },
    text: {
      primary: C.nearBlack,
      secondary: C.warmBrown,
    },
    divider: C.goldPale,
    success: {
      main: C.successDark,
      light: C.successBg,
      contrastText: C.offWhite,
    },
    warning: {
      main: C.warning,
      contrastText: C.espresso,
    },
    error: {
      main: C.dangerDark,
    },
  },
  typography: {
    fontFamily: FONTS.sans,
    h1: { fontFamily: FONTS.sans },
    h2: { fontFamily: FONTS.sans },
    h3: { fontFamily: FONTS.sans },
    h4: { fontFamily: FONTS.sans },
    h5: { fontFamily: FONTS.sans, fontWeight: 700 },
    h6: { fontFamily: FONTS.sans, fontWeight: 700 },
    body1: { fontFamily: FONTS.sans },
    body2: { fontFamily: FONTS.sans },
    caption: { fontFamily: FONTS.sans },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    ...sharedComponents,
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
          fontSize: '14px',
          fontFamily: FONTS.sans,
          fontWeight: 700,
          '&.Mui-selected': {
            color: C.espresso,
          },
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: C.gold,
      dark: C.goldDark,
      light: C.darkGoldLight,
      contrastText: C.espresso,
    },
    secondary: {
      main: C.goldDark,
      contrastText: C.creamText,
    },
    background: {
      default: C.darkBg,
      paper: C.darkSurface,
    },
    text: {
      primary: C.creamText,
      secondary: C.lightBrown,
    },
    divider: `rgba(232,216,138,0.2)`,
    success: {
      main: C.successDark,
      light: C.successBg,
    },
    warning: {
      main: C.warning,
    },
    error: {
      main: C.dangerDark,
    },
  },
  typography: {
    fontFamily: FONTS.sans,
    h1: { fontFamily: FONTS.sans },
    h2: { fontFamily: FONTS.sans },
    h3: { fontFamily: FONTS.sans },
    h4: { fontFamily: FONTS.sans },
    h5: { fontFamily: FONTS.sans, fontWeight: 700 },
    h6: { fontFamily: FONTS.sans, fontWeight: 700 },
    body1: { fontFamily: FONTS.sans },
    body2: { fontFamily: FONTS.sans },
    caption: { fontFamily: FONTS.sans },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    ...sharedComponents,
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
          fontSize: '14px',
          fontFamily: FONTS.sans,
          fontWeight: 700,
          '&.Mui-selected': {
            color: C.gold,
          },
        },
      },
    },
  },
});
